import React from 'react'
import ToggleOn from 'react-icons/lib/fa/toggle-on'
import ToggleOff from 'react-icons/lib/fa/toggle-off'
import styles from './styles.css'

export default function ToggleRow({label, active, onToggle, rowStyle = 'row'}) {
  return (
    <div className={styles[rowStyle]}>
      <div>{label}</div>
      <div className={styles.toggle} role="button" onClick={onToggle}>
        {active ? <ToggleOn color="#1bb157" size={20} /> : <ToggleOff color="#9CA3AF" size={20} />}
      </div>
    </div>
  )
}
